import { URLLotType } from '@nx/global-types'
import { cleanDoubleSlashes } from '@nx/populate-url'
import { seoName } from '@nx/seo-name'

import { domainBuilder } from '../domainBuilder/domainBuilder'

type BuildLotPathProps = {
  auctionId: number | string
  lotId: number | string
  lotName: string
  isPreview?: boolean
  lotCharacter?: string
  url?: string
  domain?: string
  extraUrlParams?: Record<string, string>
}

export function buildLotPath({
  auctionId,
  lotId,
  lotName,
  isPreview = false,
  lotCharacter = '',
  url,
  domain,
  extraUrlParams,
}: BuildLotPathProps) {
  if (url) return url

  const lotType = isPreview ? URLLotType.preview : URLLotType.lot

  const params = extraUrlParams
    ? `?${new URLSearchParams(Object.entries(extraUrlParams)).toString()}`
    : ''

  let path =
    [
      '/auction',
      auctionId,
      lotType,
      lotId + (lotCharacter || ''),
      lotName ? seoName(lotName) : undefined,
    ]
      .filter(Boolean)
      .join('/') + '/'

  if (params) {
    path += params
  }

  if (domain) {
    path = domainBuilder(domain, path)
  }

  return cleanDoubleSlashes(path)
}
